import { render, staticRenderFns } from "./videoConfig.vue?vue&type=template&id=31d3b49c&"
import script from "./videoConfig.vue?vue&type=script&lang=js&"
export * from "./videoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports